export const TableColumn = [
    { data: '', Title: '#', width: 8, position: 1 },
    { data: '', Title: 'Requisition No.',width: 300, position: 4 },
    { data: '', Title: 'Requisition Type',width: 100, position: 2 },
    { data: '', Title: 'Required On/Before',width: 85, position: 6 },
    { data: '', Title: 'Requested By',width: 85, position: 7 }, 
    { data: '', Title: 'Status',width: 85, position: 10 }, 
    { data: 'Action', Title: 'Action', position: 11 },
];